module.exports = __webpack_public_path__ + "img/jeppe.dabdc028.png";